<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--music">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15V6"/><path d="M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/><path d="M12 12H3"/><path d="M16 6H3"/><path d="M12 18H3"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">
                <span class="spotlight-result-title-text">{{ item.title }}</span>
            </div>
            <div v-if="item.subtitle" class="spotlight-result-subtitle">{{ item.subtitle }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MusicPlaylistResult',
    props: { item: Object, focused: Boolean },
    emits: ['select'],
}
</script>
